module.exports = __webpack_public_path__ + "static/media/landing-hero-image.5fcb00fd.jpg";